import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button,
  InputLabel,
  Select,
  FormControl,
  IconButton,
  CircularProgress,
  DialogActions,
  useMediaQuery,
} from "@mui/material";
import { UploadFile, Close } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  getSalesManagerByCP,
  getSalesManagerName,
} from "../../Services/LeadService";

const TicketPage = ({ onClose }) => {
  const userDetails = useSelector((state) => state.Auth.user);
  const name = userDetails?.name;
  const email = userDetails?.email;
  const mobile = userDetails?.contactNumber;
  const user_id = userDetails?.cpId;
  const other_id = userDetails?.type === "CP" ? userDetails?.cpDisplayId : userDetails?.fosDisplayId;
  const userType = userDetails?.type; 
console.log('tanaya', userType)
  console.log("userDetails::::===========", userDetails);

  const [department, setDepartment] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [categoryLevel, setCategoryLevel] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [descriptionError, setDescriptionError] = useState("");


  const [salesManagerName, setSalesManagerName] = useState("");

  useEffect(() => {
    const fetchSalesManagerName = async () => {
      const name = await getSalesManagerByCP(userDetails?.cpId);
      console.log("smname", name);
      setSalesManagerName(name);
    };

    fetchSalesManagerName();
  }, [userDetails]);
  


  const TENANT_ID = "7698a247-5850-45b5-92e4-848f2bf72d67";



  const [form, setForm] = useState({
    name: name,
    email: email,
    mobile: mobile,
    department: "",
    department_id: "",
    category: "",
    subcategory: "", 
    priority: "Medium",
    description: "",
    file: null,
    category_id: "",
    subcategory_id: "",
    user_id: user_id,
    type: "CP/FOS",
    subject_line: "",
    tenant_id: TENANT_ID,

  });

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);

    setForm((prev) => ({
      ...prev,
      file: [...(prev.file || []), ...newFiles], // merge old + new files
    }));

    console.log("Selected files:", newFiles);
  };

  const isMobile = useMediaQuery("(max-width: 600px)");

   // Update department and department_id based on userType (cp or fos)
  useEffect(() => {
    if (userType === "CP") {
      setForm((prev) => ({
        ...prev,
        department: "Channel partner",
        department_id: "66b814ee-f11e-4478-8eae-6d4290a10e5c", // Channel Partner ID
      }));
    } else if (userType === "FOS") {
      setForm((prev) => ({
        ...prev,
        department: "FOS",
        department_id: "0eb992be-c229-48ac-911e-c4e050dd15e2", // FOS ID
      }));
    }
  }, [userType]);

//  const getVJOPDepartment = async () => {
//   try {
//     const { data } = await axios.post(
//       "https://helpdesk.vjerp.com/api/user/getAllLevelOneDepartments",
//       {
//         is_internal: false,
//         tenant_id: TENANT_ID,
//       }
//     );

//     const filter = data.departments.filter((d) => d.name === "Sales");
//     if (filter.length > 0) {
//       setDepartment(filter);
//       setForm(prev => ({ ...prev, department_id: filter[0].id }));
//     }
//   } catch (error) {
//     console.log("Department fetch error:", error);
//   }
// };



// const getSubDepartments = async (parentId) => {
//   if (!parentId) return;

//   try {
//     const { data } = await axios.get(
//       `https://helpdesk.vjerp.com/api/user/getDeparmentsByParentId/${parentId}`,
//       {
//         params: { tenant_id: TENANT_ID },
//       }
//     );

//     // CASE 1: Sub-departments found
//     if (data.success && Array.isArray(data.departments) && data.departments.length > 0) {
//       setSubDepartments(data.departments);

//       const defaultSubDept =
//         data.departments.find((d) => d.name === "Channel partners / FOS") ||
//         data.departments[0];

//       if (defaultSubDept) {
//         setForm((prev) => ({
//           ...prev,
//           subdepartment: defaultSubDept.name,
//           subdepartment_id: defaultSubDept.id,
//         }));

//         // Load categories for selected sub-department
//         getLevelOneCategories(defaultSubDept.id);
//       }
//     } 
    
//     // CASE 2: No sub-departments → still call categories based on parentId
//     else {
//       console.warn("No sub-departments found → loading categories directly.");

//       setSubDepartments([]); // empty array
//       setForm((prev) => ({
//         ...prev,
//         subdepartment: "",
//         subdepartment_id: "",
//       }));

//       // LOAD CATEGORIES USING PARENT DEPARTMENT ID
//       getLevelOneCategories(parentId);
//     }
//   } catch (err) {
//     console.error("Sub-department fetch error:", err);

//     // Fail-safe: still load categories
//     getLevelOneCategories(parentId);
//   }
// };


 

 const getLevelOneCategories = async (deptId) => {
  if (!deptId) return;

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/getAllLevelOneCategories/${deptId}`,
      {
        params: { tenant_id: TENANT_ID },
      }
    );

    if (data.success) {
      setCategoryLevel(data.categories || []);
    } else {
      setCategoryLevel([]);
    }
  } catch (err) {
    console.error("Category error:", err);
    setCategoryLevel([]);
  }
};


 
const getSubCategories = async (parentId) => {
  try {
    // FALLBACK: if no sub-department, use main department_id
    const departmentIdToUse = form.department_id || form.department_id;

    if (!departmentIdToUse || !parentId) {
      console.warn("Missing department_id or parent_id:", {
        departmentIdToUse,
        parentId,
      });
      return;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/get-subcategories`,
      {
        params: {
          department_id: departmentIdToUse,
          parent_id: parentId,
          tenant_id: TENANT_ID,
        },
      }
    );

    if (data.success) {
      setSubCategories(data.subcategories || []);
    } else {
      setSubCategories([]);
    }
  } catch (err) {
    console.error("Subcategory error:", err);
    setSubCategories([]);
  }
};

  const submitTicket = async () => {
    const required = [
      "name",
      "email",
      "mobile",
      "department",
      "category",
      "subcategory",
      "priority",
      "subject_line",
      "tenant_id",
      
    ];
    for (let field of required) {
      if (!form[field])
        return toast.error(`Please fill in the ${field} field.`);
    }

    if (form.description.length < 50 || form.description.length > 150) {
      setDescriptionError("Description must be between 50 and 150 characters.");
      return;
    }
    setDescriptionError("");

    setLoading(true);
    setIsDisabled(true);
    try {
      const formData = new FormData();
      // formData.append("department_id", form.department_id);
      formData.append(
        "department_id",
        form.department_id || form.department_id
      );
      formData.append("category_id", form.category_id);
      formData.append("sub_category_id", form.subcategory_id);
      formData.append("priority_level", form.priority);
      formData.append("description", form.description);
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("phone", form.mobile);
      formData.append("department_name", form.department);
      formData.append("category_name", form.category);
      formData.append("subcategory_name", form.subcategory);
      if (form.file && form.file.length > 0) {
        form.file.forEach((file) => {
          formData.append("attachments", file); // matches multer key
        });
      }
      formData.append("user_id", form.user_id);
      formData.append("type", form.type);
      formData.append("subject_line", form.subject_line)
      formData.append("tenant_id", TENANT_ID);
      formData.append("other_id", other_id);

       console.log('formData', form)

      const res = await axios.post(
        `${process.env.REACT_APP_HELPDESK_API_URL}/api/user/create-ticket`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (res.data.success) {
        toast.success("Ticket submitted successfully!");
        onClose(); // close modal
      }
      if (
        res.data.success === false &&
        res.data.message === "No users found in department"
      ) {
        console.error(res.data.message);
        throw new Error("No users found in department");
      }
    } catch (err) {
      toast.error("Failed to submit ticket.");
      console.error(err);
    } finally {
      setLoading(false);
      setIsDisabled(false);
    }
  };

  const validateMobile = (mobile) => {
    const regex = /^[0-9]{10}$/;
    return regex.test(mobile);
  };

  // useEffect(() => {
  //   getVJOPDepartment();
  // }, []);

  // whenever department_id is set, auto fetch sub-departments & categories
  useEffect(() => {
    if (form.department_id) {
      console.log("Auto-fetching for department_id:", form.department_id);
      // getSubDepartments(form.department_id);
      getLevelOneCategories(form.department_id);
    }
  }, [form.department_id]);

  const priorities = [
    // { name: "Low", id: 1 },
    { name: "Medium", id: 2 },
    { name: "High", id: 3 },
  ];

 

  const handleDropdownChange = (
    event,
    optionsList,
    keyName,
    linkedLogic = null
  ) => {
    const selectedValue = event.target.value;
    const selectedOption = optionsList.find(
      (opt) => opt.name === selectedValue
    );

    if (selectedOption) {
      setForm((prev) => ({
        ...prev,
        [keyName]: selectedOption.name,
        [`${keyName}_id`]: selectedOption.id,
        ...(keyName === "department" && {
          department: "",
          department_id: "",
        }),
        ...(keyName === "category" && {
          subcategory: "",
          subcategory_id: "",
        }),
      }));

      if (linkedLogic && typeof linkedLogic === "function") {
        linkedLogic(selectedOption.id);
      }
    } else {
      setForm((prev) => ({
        ...prev,
        [keyName]: "",
        [`${keyName}_id`]: "",
        ...(keyName === "department" && {
          // subdepartment: "",
          // subdepartment_id: "",
        }),
        ...(keyName === "category" && {
          subcategory: "",
          subcategory_id: "",
        }),
      }));
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: "100%", overflow: "auto" }}>
      {/* <Typography variant="h6" gutterBottom>Create New Support Ticket</Typography> */}
      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={6}>
          <InputLabel
            className="inputLabel"
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Name <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid #ccc",
                height: "45px",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1rem",

                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#ccc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ccc",
                },
              },
            }}
            required
            fullWidth
            // label="Your Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel
            className="inputLabel"
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1rem",
            }}
          >
            Email <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid #ccc",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1rem",
                height: "45px",
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#ccc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ccc",
                },
              },
            }}
            fullWidth
            // label="Email"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel
            className="inputLabel"
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1rem",
            }}
          >
            Mobile <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid #ccc",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1rem",
                height: "45px",
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#ccc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ccc",
                },
              },
            }}
            fullWidth
            // label="Mobile"
            name="mobile"
            value={form.mobile}
            onChange={handleChange}
          />
        </Grid> */}

        {/* <Grid item xs={12} sm={6}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Department <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            name="department"
            value={form.department}
            onChange={handleChange}
            fullWidth
            // label="Department"
            sx={{
              fontFamily: "Rubik",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
              height: "45px",
              border: "1px solid #ccc",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
            }}
          >
            {department.map((d) => (
              <MenuItem key={d.id} value={d.name}>
                {d.name}
              </MenuItem>
            ))}
          </Select>
        </Grid> */}

        {/* <Grid item xs={12} sm={6}>
            <InputLabel  sx={{ mb: 1 , fontFamily: 'Rubik',color:"black"}}>Category  <span style={{color: 'red'}}>*</span></InputLabel>
            <Select
               sx={{
                height:'45px',
                border:"1px solid #ccc",
                   fontFamily: 'Rubik',
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ccc",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ccc",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ccc",
                },
              }}
              fullWidth
              name="category"
              value={form.category}
              onChange={(e) => {
                const selected = categoryLevel.find(
                  (cat) => cat.name === e.target.value
                );
                if (selected) {
                  setForm((prev) => ({
                    ...prev,
                    category: selected.name,
                    category_id: selected.id,
                    subcategory: '',
                    subcategory_id: '',
                  }));
                  getSubCategories(selected.id);
                }
              }}
              // label="Category"
              >
              {categoryLevel.map((cat) => (
                <MenuItem key={cat.id} value={cat.name}>
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
        </Grid> */}

        {/* <Select
  sx={{
    height: '45px',
    border: '1px solid #ccc',
    fontFamily: 'Rubik',
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #ccc",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #ccc",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #ccc",
    },
  }}
  fullWidth
  displayEmpty
  name="category"
  value={form.category}
  onChange={handleCategoryChange} // ✅ clean and separated
>
  <MenuItem value="">
    <em>-- Select --</em>
  </MenuItem>
  {categoryLevel.map((cat) => (
    <MenuItem key={cat.id} value={cat.name}>
      {cat.name}
    </MenuItem>
  ))}
</Select> */}

        {/* Sub-Department Dropdown */}
        {/* <Grid item xs={12} sm={6}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Sub-Department <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            sx={{
              height: "45px",
              border: "1px solid #ccc",
              fontFamily: "Rubik",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
            }}
            name="subdepartment"
            value={form.subdepartment || ""}
            onChange={(e) =>
              handleDropdownChange(e, subDepartments, "subdepartment")
            }
            fullWidth
            disabled={subDepartments.length === 0}
            displayEmpty
          >
            <MenuItem value="">
              <em>-- Select Sub-Department --</em>
            </MenuItem>
            {subDepartments.map((sd) => (
              <MenuItem
                key={sd.id}
                value={sd.name}
                sx={{ fontSize: isMobile ? "1.9rem" : "1.3rem" }}
              >
                {sd.name}
              </MenuItem>
            ))}
          </Select>
        </Grid> */}

        <Grid item xs={12} sm={6}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Category <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            sx={{
              height: "45px",
              border: "1px solid #ccc",
              fontFamily: "Rubik",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
            }}
            name="category"
            value={form.category}
            onChange={(e) =>
              handleDropdownChange(
                e,
                categoryLevel,
                "category",
                getSubCategories
              )
            }
            displayEmpty
            fullWidth
          >
            <MenuItem value="">
              <em>-- Select --</em>
            </MenuItem>
            {categoryLevel.map((cat) => (
              <MenuItem
                key={cat.id}
                value={cat.name}
                sx={{ fontSize: isMobile ? "1.9rem" : "1.3rem" }}
              >
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
            disabled={form.category === ""}
          >
            Subcategory <span style={{ color: "red" }}>*</span>
          </InputLabel>
          {/* <Select
               sx={{
                height:'45px',
                   fontFamily: 'Rubik',
                border:"1px solid #ccc",
                  "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ccc",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ccc",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #ccc",
                },
              }}
              fullWidth
              name="subcategory"
              // label="Subcategory"
              value={form.subcategory}
              onChange={(e) => {
                const selected = subCategories.find(
                  (sub) => sub.name === e.target.value
                );
                if (selected) {
                  setForm((prev) => ({
                    ...prev,
                    subcategory: selected.name,
                    subcategory_id: selected.id,
                  }));
                }
              }}
              disabled={subCategories.length === 0}>
              {subCategories.map((sub) => (
                <MenuItem key={sub.id} value={sub.name}>
                  {sub.name}
                </MenuItem>
              ))}
            </Select> */}
          <Select
            sx={{
              height: "45px",
              fontFamily: "Rubik",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
              border: "1px solid #ccc",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
            }}
            name="subcategory"
            value={form.subcategory}
            onChange={(e) =>
              handleDropdownChange(e, subCategories, "subcategory")
            }
            displayEmpty
            fullWidth
          >
            <MenuItem value="">
              <em>-- Select --</em>
            </MenuItem>
            {subCategories.map((sub) => (
              <MenuItem
                key={sub.id}
                value={sub.name}
                sx={{ fontSize: isMobile ? "1.9rem" : "1.3rem" }}
              >
                {sub.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Priority <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            sx={{
              height: "45px",
              border: "1px solid #ccc",
              fontFamily: "Rubik",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #ccc",
              },
            }}
            fullWidth
            displayEmpty
            name="priority"
            value={form.priority}
            // onChange={handleChange}
            onChange={(e) => handleDropdownChange(e, priorities, "priority")}
            // label="Priority"
          >
            <MenuItem value="">
              <em>-- Select --</em>
            </MenuItem>
            {priorities.map((priority) => (
              <MenuItem
                key={priority.id}
                value={priority.name}
                sx={{ fontSize: isMobile ? "1.9rem" : "1.3rem" }}
              >
                {priority.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Subject <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid #ccc",
                height: "45px",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1.3rem",
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#ccc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ccc",
                },
              },
            }}
            placeholder="E.g. Unable to update bank details"
            fullWidth
            name="subject_line"
            value={form.subject_line || ""}
            onChange={handleChange}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Description
          </InputLabel>
          <TextField
            multiline
            rows={3}
            fullWidth
            // label="Description"
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid #ccc",
                height: "100px",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1.3rem",
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#ccc",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ccc",
                },
              },
            }}
            name="description"
            value={form.description}
            onChange={handleChange}
          />
        </Grid> */}

        <Grid item xs={12}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Description
          </InputLabel>
          <TextField
            multiline
            rows={3}
            fullWidth
            name="description"
            value={form.description}
            onChange={(e) => {
              handleChange(e);
              if (descriptionError) setDescriptionError(""); // clear error while typing
            }}
            inputProps={{
              minLength: 50,
              maxLength: 150,
            }}
            error={Boolean(descriptionError)}
            helperText={
              descriptionError || `${form.description.length}/150 characters`
            }
            FormHelperTextProps={{
              sx: {
                fontSize: isMobile ? "1.6rem" : "1.2rem",
                fontFamily: "Rubik",
                color: descriptionError ? "red" : "inherit", // red error text
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                border: "1px solid #ccc",
                height: "100px",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1.3rem",
                "& fieldset": { borderColor: "#ccc" },
                "&:hover fieldset": { borderColor: "#ccc" },
                "&.Mui-focused fieldset": { borderColor: "#ccc" },
              },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel
            sx={{
              mb: 1,
              fontFamily: "Rubik",
              color: "black",
              fontSize: isMobile ? "1.9rem" : "1.3rem",
            }}
          >
            Attachments (Optional)
          </InputLabel>
          <Box
            sx={{
              border: "2px dashed #ccc",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              backgroundColor: "#fafafa",
            }}
          >
            <Typography
              sx={{
                color: "black",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1.3rem",
              }}
              mb={1}
            >
              Upload files or drag and drop
            </Typography>

            <input
              type="file"
              accept="image/*"
              id="file-upload"
              multiple // ✅ Add this
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            <label htmlFor="file-upload">
              <IconButton component="span" color="primary">
                <UploadFile fontSize="large" />
              </IconButton>
            </label>

            <Typography
              sx={{
                color: "black",
                fontFamily: "Rubik",
                fontSize: isMobile ? "1.9rem" : "1.3rem",
              }}
            >
              JPG or PNG up to 5MB
            </Typography>

            {form.file && form.file.length > 0 && (
              <Box mt={1}>
                {form.file.map((f, idx) => (
                  <Box key={idx} display="flex" alignItems="center" gap={1}>
                    <Typography variant="body2" sx={{ color: " #1570EF" }}>
                      {f.name}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() =>
                        setForm((prev) => ({
                          ...prev,
                          file: prev.file.filter((_, i) => i !== idx),
                        }))
                      }
                      sx={{ color: " #1570EF" }}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <DialogActions>
            <Button
              onClick={onClose}
              sx={{
                float: "right",
                background: isDisabled === true ? "#ccc" : " #1570EF",
                textTransform: "none",
                "&:hover": { background: " #1570EF" },
                color: "#fff",
                fontSize: "16px",
                fontFamily: "Rubik",
                width: isMobile ? "100%" : "200px",
              }}
            >
              Cancel
            </Button>
            <Button
              sx={{
                float: "right",
                background: isDisabled === true ? "#ccc" : " #1570EF",
                textTransform: "none",
                "&:hover": { background: " #1570EF" },
                color: "#fff",
                fontSize: "16px",
                fontFamily: "Rubik",
                width: isMobile ? "100%" : "200px",
              }}
              disabled={isDisabled}
              onClick={submitTicket}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : isMobile ? (
                "Submit"
              ) : (
                "Submit Ticket"
              )}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TicketPage;
